import { Component } from '../types/common';
import Animator from './Animator/Animator';
import ArrayRepeater from './ArrayRepeater/ArrayRepeater';
import BlueprintEditor from './BlueprintEditor/BlueprintEditor';
import Button from './Button/Button';
import ButtonBar from './Buttonbar/ButtonBar';
import Carousel from './Carousel/Carousel';
import CheckBox from './CheckBox/CheckBox';
import Dropdown from './Dropdown/Dropdown';
import FileUpload from './FileUpload/FileUpload';
import Gallery from './Gallery/Gallery';
import Grid from './Grid/Grid';
import Icon from './Icon/Icon';
import Iframe from './Iframe/Iframe';
import Image from './Image/Image';
import Link from './Link/Link';
import Menu from './Menu/Menu';
import Page from './Page/Page';
import Popover from './Popover/Popover';
import Prompt from './Prompt/Prompt';
import DraftAgent from './DraftAgent/DraftAgent';
import Popup from './Popup/Popup';
import ProgressBar from './ProgressBar/ProgressBar';
import RadioButton from './RadioButton/RadioButton';
import ModelViewer from './ModelViewer/ModelViewer';
import ParticleField from './ParticleField/ParticleField';
import ScrollScene from './ScrollScene/ScrollScene';
import ShaderBackground from './ShaderBackground/ShaderBackground';
import Shortcut from './Shortcut/Shortcut';
import Stepper from './Stepper/Stepper';
import SubPage from './SubPage/SubPage';
import Svg from './Svg/Svg';
import {
	Table,
	TableColumn,
	TableColumnHeader,
	TableColumns,
	TableDynamicColumn,
	TableDynamicGroupedColumn,
	TableEmptyGrid,
	TableGrid,
	TablePreviewGrid,
	TableRow,
} from './TableComponents';

import Tabs from './Tabs/Tabs';
import ThemeSwitcher from './ThemeSwitcher/ThemeSwitcher';
import Tags from './Tags/Tags';
import Text from './Text/Text';
import TextArea from './TextArea/TextArea';
import TextBox from './TextBox/TextBox';
import TextList from './TextList/TextList';
import Tree from './Tree/Tree';
import ToggleButton from './ToggleButton/ToggleButton';
import Video from './Video/Video';
import ImageWithBrowser from './ImageWithBrowser/ImageWithBrowser';
import ColorPicker from './ColorPicker/ColorPicker';
import SectionGrid from './SectionGrid/SectionGrid';
import PhoneNumber from './PhoneNumber/PhoneNumber';
import SmallCarousel from './SmallCarousel/SmallCarousel';
import Otp from './Otp/Otp';
import Calendar from './Calendar/Calendar';
import RangeSlider from './RangeSlider/RangeSlider';
import Timer from './Timer/Timer';
import MarkdownTOC from './MarkdownTOC/MarkdownTOC';
import Audio from './Audio/Audio';
import SSEventListener from './SSEventListener/SSEventListener';
import Chart from './Chart/Chart';
import FileSelector from './FileSelector/FileSelector';
import Form from './Form/Form';
import AnalyticsHeatmap from './AnalyticsHeatmap/AnalyticsHeatmap';
import MapPicker from './MapPicker/MapPicker';
import SignaturePad from './SignaturePad/SignaturePad';

import MarkdownEditor from './MarkdownEditor/MarkdownEditor';
import ThemeEditor from './ThemeEditor/ThemeEditor';
import FillerDefinitionEditor from './FillerDefinitionEditor/FillerDefinitionEditor';
import FillerValueEditor from './FillerValueEditor/FillerValueEditor';
import KIRunEditor from './KIRunEditor/KIRunEditor';
import FormEditor from './FormEditor/FormEditor';
import PageEditor from './PageEditor/PageEditor';
import SchemaBuilder from './SchemaBuilder/SchemaBuilder';
import SchemaForm from './SchemaForm/SchemaForm';
import TemplateEditor from './TemplateEditor/TemplateEditor';
import TextEditor from './TextEditor/TextEditor';

const componentMap = new Map<string, Component>([
	[BlueprintEditor.name, BlueprintEditor],
	[Button.name, Button],
	[ButtonBar.name, ButtonBar],
	[Grid.name, Grid],
	[Page.name, Page],
	[CheckBox.name, CheckBox],
	[RadioButton.name, RadioButton],
	[ToggleButton.name, ToggleButton],
	[TextBox.name, TextBox],
	[Link.name, Link],
	[ArrayRepeater.name, ArrayRepeater],
	[Popup.name, Popup],
	[Dropdown.name, Dropdown],
	[Menu.name, Menu],
	[Tags.name, Tags],
	[Image.name, Image],
	[Svg.name, Svg],
	[ShaderBackground.name, ShaderBackground],
	[ModelViewer.name, ModelViewer],
	[ParticleField.name, ParticleField],
	[ScrollScene.name, ScrollScene],
	[Tabs.name, Tabs],
	[ThemeSwitcher.name, ThemeSwitcher],
	[Icon.name, Icon],
	[Text.name, Text],
	[TextList.name, TextList],
	[Tree.name, Tree],
	[Shortcut.name, Shortcut],
	[Stepper.name, Stepper],
	[Table.name, Table],
	[TableGrid.name, TableGrid],
	[TableEmptyGrid.name, TableEmptyGrid],
	[TablePreviewGrid.name, TablePreviewGrid],
	[TableColumns.name, TableColumns],
	[TableColumn.name, TableColumn],
	[TableColumnHeader.name, TableColumnHeader],
	[ProgressBar.name, ProgressBar],
	[SubPage.name, SubPage],
	[Iframe.name, Iframe],
	[Carousel.name, Carousel],
	[Popover.name, Popover],
	[FileUpload.name, FileUpload],
	[Video.name, Video],
	[Gallery.name, Gallery],
	[TextArea.name, TextArea],
	[TableDynamicColumn.name, TableDynamicColumn],
	[TableDynamicGroupedColumn.name, TableDynamicGroupedColumn],
	[Animator.name, Animator],
	[ImageWithBrowser.name, ImageWithBrowser],
	[ColorPicker.name, ColorPicker],
	[SectionGrid.name, SectionGrid],
	[PhoneNumber.name, PhoneNumber],
	[SmallCarousel.name, SmallCarousel],
	[Otp.name, Otp],
	[Calendar.name, Calendar],
	[RangeSlider.name, RangeSlider],
	[Timer.name, Timer],
	[MarkdownEditor.name, MarkdownEditor],
	[MarkdownTOC.name, MarkdownTOC],
	[Audio.name, Audio],
	[SSEventListener.name, SSEventListener],
	[Chart.name, Chart],
	[AnalyticsHeatmap.name, AnalyticsHeatmap],
	[MapPicker.name, MapPicker],
	[SignaturePad.name, SignaturePad],
	[FileSelector.name, FileSelector],
	[FillerDefinitionEditor.name, FillerDefinitionEditor],
	[FillerValueEditor.name, FillerValueEditor],
	[KIRunEditor.name, KIRunEditor],
	[FormEditor.name, FormEditor],
	[PageEditor.name, PageEditor],
	[SchemaBuilder.name, SchemaBuilder],
	[SchemaForm.name, SchemaForm],
	[TemplateEditor.name, TemplateEditor],
	[TextEditor.name, TextEditor],
	[ThemeEditor.name, ThemeEditor],
	[Form.name, Form],
	[TableRow.name, TableRow],
	[Prompt.name, Prompt],
	[DraftAgent.name, DraftAgent],
]);

export default componentMap;
